export const scrolledDownZeroVar = '--scrolled-down-zero';

export const scrolledDownHiddenVar = '--scrolled-down-hidden';
export const scrolledDownVisibleVar = '--scrolled-down-visible';
